/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import api from '../../../services/api';

import React, { useState, useEffect, useCallback } from 'react';
import CryptoJS from "crypto-js"
import 'moment/locale/pt';

import ReactExport from "react-export-excel";

import { replaceDotForComma } from "../../../utils/Regex"
import { Box, Typography, Button } from '@mui/material';
import CustomizedTables from '../../../components/Table';
import FixedContainer from '../../../components/Container';
import LoadingComponent from '../../../components/LoadingComponent';
import { GetFetch } from '../../../services/apiBase';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Category = (props) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [sheets, setSheets] = useState(null);

  const COLUMNSTABLE = [
    {
      headerName: 'ID',
      type: 'default',
      value: {
        first: {
          value: 'id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Valor de investimento inicial',
      type: 'money',
      value: {
        first: {
          value: 'amount_start'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Valor de investimento final',
      type: 'money',
      value: {
        first: {
          value: 'amount_end'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Categoria',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      },
      noData: 'Não informado'
    },
  ]

  const getSheet = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch('/financial/listMainTradeAgreement');
      setSheets(response.data);
      setError(false)
    } catch (error) {
      setError(true)
     console.log(error)
    } finally {
      setLoading(false)
    }
  }, []);

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  const exportExcelComponent = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 1,
        marginTop: 1,
      }}>
        <ExcelFile element={
          <Button variant="contained">Exportar para Excel</Button>
        } filename="Politicas_comerciais-Por_Categoria">
          <ExcelSheet data={sheets} name="Politicas_comerciais-Por_Categoria">
            <ExcelColumn label="Valor de Investimento Inicio" value={(col) => col.amount_start ? Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(col.amount_start) : "Não informado"}/>
            <ExcelColumn label="Valor de Investimento Fim" value={(col) => col.amount_end ? Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(col.amount_end) : "Não informado"}/>
            <ExcelColumn label="Taxa" value={(col) => col.rate ? col.rate.toString().match(/./) != null ? `${replaceDotForComma(col.rate.toString())} %` : `${col.rate} %` : "Não informado"}/>
            <ExcelColumn label="Categoria" value={(col) => col.type ? col.type : "Não informado"} />
          </ExcelSheet>
        </ExcelFile>
      </Box>
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        <CustomizedTables
          data={sheets}
          columns={COLUMNSTABLE}
        />
      </Box>
    )
  }

  useEffect(() => {
    getSheet()
  }, []);
  
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
              <>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  Politicas comerciais/Por categoria
                </Typography>
                {exportExcelComponent()}
                {tableComponent()}
              </>
            }
        </Box>
      </FixedContainer>
    </>
  );
}

export default Category;
